import mTable from './Main.vue';

export default mTable;
